import { LOCAL_STORAGE_CONSTANTS } from "../constants";

export const getLoggedInUserEmail = (): string =>
  localStorage.getItem(LOCAL_STORAGE_CONSTANTS?.email) || "";
